/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import customHttp from "../../services/customHTTP";
import {
	CircularProgress,
	Box,
	Typography,
	Pagination,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Checkbox,
	FormControlLabel,
	Divider,
	Button,
	Alert,
	useTheme,
} from "@mui/material"; // Material UI components
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"; // Icon for accordion expand
import ProductCard from "../../components/ProductCard/ProductCard"; // Import ProductCard component
import { useSite } from "../../context/siteContext"; // Import site context for filtering (if needed)
import PageTitle from "../../components/PageTitle/PageTitle";
import "./Products.css";
import ContextFilterAndSort from "../../components/ContextFilterAndSort/ContextFilterAndSort";
import PageNotFound from "../PageNotFound/PageNotFound";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import DescriptionIcon from "@mui/icons-material/Description";
import { ASSETS_BASE_URL, SERVER_BASE_URL, RSPL_LIST } from "../../config";
import { useAuth } from "../../context/authContext";
import MultipleModelViewer from "../../components/MultipleModelViewer/MultipleModelViewer";

// const pageOptions = [
//     { key: 10, text: "10", value: 10 },
//     { key: 25, text: "25", value: 25 },
//     { key: 50, text: "50", value: 50 },
//     { key: 100, text: "100", value: 100 },
// ];

const Products = () => {
	const rsplMapping = Object.fromEntries(RSPL_LIST.flatMap(({ key, value }) => key.map((k) => [k, value])));
	const [modalOpen, setModalOpen] = useState(false);
	const { machineID } = useParams(); // Extract machineID from URL
	const [products, setProducts] = useState([]);
	const [originalProducts, setOriginalProducts] = useState([]);
	const [loading, setLoading] = useState(true);
	const [machine_name, setmachine_name] = useState([]);
	const [machine_number, setmachine_number] = useState([]);
	const [error, setError] = useState(null);
	const [pageSize, setPageSize] = useState(50); // Default page size
	const [currentPage, setCurrentPage] = useState(1); // Default current page
	const [totalPages, setTotalPages] = useState(0); // Total number of pages based on pageSize and totalItems
	const [productSearchTerm, setProductSearchTerm] = useState(""); // Search term for products
	const [selectedFilters, setSelectedFilters] = useState([]); // Default filter
	const { selectedSite, selectedSiteCurrency } = useSite(); // Use site context (if needed)
	const [sortOption, setSortOption] = useState("");
	const [has3DModel, setHas3DModel] = useState(false);
	const [has2DModel, setHas2DModel] = useState(false);
	const [m3DButtonLoading, setM3DButtonLoading] = useState(false);
	const [selectedChangePart, setSelectedChangePart] = useState(false);
	const [hasMultiple3DModels, setHasMultiple3DModels] = useState(false);
	const navigate = useNavigate();
	const { user } = useAuth();
	const theme = useTheme();

	const categoryArray = [...new Set(RSPL_LIST.map((item) => item.value))];
	categoryArray.push("Other");

	const sortOptions = ["Name Asc", "Name Desc", "Number Asc", "Number Desc", "Price Asc", "Price Desc"];

	const handleProductSearchChange = (value) => {
		setProductSearchTerm(value);
	};

	const handleFilterChange = (event) => {
		const { value, checked } = event.target;
		setSelectedFilters((prevFilters) =>
			checked ? [...prevFilters, value] : prevFilters.filter((filter) => filter !== value)
		);
	};

	const handleAllChange = (event) => {
		if (event.target.checked) {
			// Select all filters
			setSelectedFilters(categoryArray);
		} else {
			// Deselect all filters
			setSelectedFilters([]);
		}
	};

	const handleSortChange = (value) => {
		setSortOption(value);
		if (value === "Name Asc") {
			setProducts((prevProducts) =>
				[...prevProducts].sort((a, b) => a.product_name.trim().localeCompare(b.product_name.trim()))
			);
		} else if (value === "Name Desc") {
			setProducts((prevProducts) =>
				[...prevProducts].sort((a, b) => b.product_name.trim().localeCompare(a.product_name.trim()))
			);
		} else if (value === "Number Asc") {
			setProducts((prevProducts) =>
				[...prevProducts].sort((a, b) => a.product_name.trim().localeCompare(b.product_name.trim()))
			);
		} else if (value === "Number Desc") {
			setProducts((prevProducts) =>
				[...prevProducts].sort((a, b) => b.product_name.trim().localeCompare(a.product_name.trim()))
			);
		} else if (value === "Price Asc") {
			setProducts((prevProducts) =>
				[...prevProducts].sort((a, b) => a.product_sell_price - b.product_sell_price)
			);
		} else if (value === "Price Desc") {
			setProducts((prevProducts) =>
				[...prevProducts].sort((a, b) => b.product_sell_price - a.product_sell_price)
			);
		}
	};

	useEffect(() => {
		const fetchMachineDetails = async () => {
			try {
				const reqBody = {
					machines: [machineID],
					// Additional filters can go here (e.g., selectedSite if needed)
				};

				const response = await customHttp.post("/machines/by-ids", reqBody);

				if (response.data.success) {
					// Extract machine_name and machine_number
					const machineData = response.data.data[0]; // Assuming you're getting one object, not an array of machines
					setmachine_name(machineData.machine_name);
					setmachine_number(machineData.machine_number);
				} else {
					setError("Failed to fetch data: No success flag.");
				}
			} catch (err) {
				setError("Failed to fetch data: " + err.message);
			}
		};

		fetchMachineDetails();
	}, []);

	useEffect(() => {
		const checkResources = async () => {
			const product3DModelUrl = `${SERVER_BASE_URL}/stock-models/3D/${machine_number}.html`;
			const product2DModelUrl = `${SERVER_BASE_URL}/stock-models/2D/${machine_number}.pdf`;

			try {
				// Check if the 3D model exists
				const modelResponse = await fetch(product3DModelUrl, { method: "HEAD" });
				if (modelResponse.ok) {
					setHas3DModel(true);
					setHas2DModel(false);
				} else {
					const model2dResponse = await fetch(product2DModelUrl, { method: "HEAD" });
					if (model2dResponse.ok) {
						setHas2DModel(true);
						setHas3DModel(false);
					} else {
						setHas2DModel(false);
						setHas3DModel(false);
					}
				}
			} catch (error) {
				console.warn("Resource check failed. Using defaults.");
			}
		};
		if (machine_number) {
			checkResources();
		}
	}, [machine_number]);

	useEffect(() => {
		const checkResources = async () => {
			try {
				const base3DUrl = `${SERVER_BASE_URL}/stock-models/3D/${machine_number}.html`;
				const changePartUrl = `${SERVER_BASE_URL}/stock-models/3D/${machine_number}_CP.html`;

				// Step 1: Check for base model and change part
				const [resBase, resCP] = await Promise.all([
					fetch(base3DUrl, { method: "HEAD" }),
					fetch(changePartUrl, { method: "HEAD" }),
				]);

				let found3D = resBase.ok;
				let foundCP = resCP.ok;
				let multiple3D = false;

				// Step 2: If base model not found, check for multiple numbered models
				if (!found3D) {
					let index = 1;
					let modelCount = 0;

					while (true) {
						const suffix = index.toString().padStart(2, "0");
						const modelUrl = `${SERVER_BASE_URL}/stock-models/3D/${machine_number}_${suffix}.html`;

						const res = await fetch(modelUrl, { method: "HEAD" });

						if (res.ok) {
							modelCount++;
							index++;
						} else {
							break;
						}
					}

					if (modelCount > 0) {
						found3D = true;
						multiple3D = modelCount > 1;
					}
				}

				setHas3DModel(found3D);
				setHasMultiple3DModels(multiple3D);

				// Step 3: Fallback to 2D
				if (!found3D && !foundCP) {
					const model2dResponse = await fetch(`${SERVER_BASE_URL}/stock-models/2D/${machine_number}.pdf`, {
						method: "HEAD",
					});
					setHas2DModel(model2dResponse.ok);
				} else {
					setHas2DModel(false);
				}
			} catch (error) {
				console.warn("Resource check failed. Using defaults.");
				setHas2DModel(false);
				setHas3DModel(false);
				setHasMultiple3DModels(false);
			}
		};

		checkResources();
	}, [machine_number]);

	const handle3DButtonClick = async () => {
		if (hasMultiple3DModels) {
			setModalOpen(true);
		} else {
			setM3DButtonLoading(true); // Show loading state

			try {
				// Make the API call
				const response = await customHttp.get("/models/process-modelfile", {
					params: {
						filename: machine_number,
						machinename: machine_name,
						currency: selectedSiteCurrency.toUpperCase(),
						loggedinUser: user.user_id,
						ecommachineid: machineID,
						baseColor: theme.palette.primary.main,
						selectedSite,
					},
				});

				if (response.status === 200) {
					const backendUrl = SERVER_BASE_URL || "";
					const fullUrl = backendUrl + response.data.url; // Construct the full URL
					setM3DButtonLoading(false);
					window.open(fullUrl); // Redirect after 1 second delay
				}
			} catch (err) {
				console.error("Error fetching the model:", err);
			}
		}
	};

	useEffect(() => {
		const fetchProducts = async () => {
			try {
				const reqBody = {
					machine_id: machineID,
					// Additional filters can go here (e.g., selectedSite if needed)
				};

				const response = await customHttp.post("/products/bymachineid", reqBody);
				if (response.data.success) {
					const productsWithType = response.data.data.map((product) => {
						const product_meta = product.product_meta;
						const cpStatus = product_meta.some((meta) => {
							if (meta.meta_key === "change_part") {
								const metaValue = JSON.parse(meta.meta_value);
								return metaValue.status === true;
							}
							return false;
						});
						const productType = rsplMapping[product.product_rspl_code]
							? rsplMapping[product.product_rspl_code]
							: "Other";
						// Add the ProductType to each product object
						return { ...product, ProductType: productType, changePart: cpStatus };
					});
					console.log("Products With Type: ", productsWithType);
					setOriginalProducts(productsWithType);
					setProducts(productsWithType); // Set the products with ProductType
					setTotalPages(Math.ceil(productsWithType.length / pageSize));
					// Calculate total pages
					setDefaultFilters(productsWithType); // Set the default filters based on ProductType
				} else {
					setError("Failed to fetch data: No success flag.");
				}
			} catch (err) {
				setError("Failed to fetch data: " + err.message);
			} finally {
				setLoading(false);
			}
		};

		fetchProducts();
	}, [machineID, selectedSite]);

	// Set default filters based on unique ProductType values
	const setDefaultFilters = (products) => {
		setSelectedFilters(categoryArray);
	};

	const filteredProducts = products
		.filter((item) => {
			// Filter based on selected filters (Critical, Maintenance, Other)
			if (selectedFilters.length === 0) return true; // Show all if no filters selected
			return selectedFilters.includes(item.ProductType);
		})
		.filter(
			(item) =>
				item.product_name.toLowerCase().includes(productSearchTerm.toLowerCase()) ||
				item.product_number.toLowerCase().includes(productSearchTerm.toLowerCase())
		);

	useEffect(() => {
		setTotalPages(Math.ceil(filteredProducts.length / pageSize));
	}, [filteredProducts, pageSize]);

	const handleShowChangeParts = () => {
		setSelectedChangePart((prev) => {
			const newSelectedChangePart = !prev;

			if (newSelectedChangePart) {
				// Filter products when checkbox is checked
				const filteredProducts = products.filter((item) => item.changePart === true);
				setProducts(filteredProducts);
				setTotalPages(Math.ceil(filteredProducts.length / pageSize));
			} else {
				// Show all products when checkbox is unchecked
				setProducts(originalProducts); // Ensure you have the original products stored
				setTotalPages(Math.ceil(originalProducts.length / pageSize));
			}

			return newSelectedChangePart;
		});
	};

	// If data is loading, display a loading spinner
	if (loading) {
		return (
			<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
				<CircularProgress />
			</Box>
		);
	}

	// If there's an error, display the error message
	if (error) {
		return (
			<Box sx={{ display: "flex", justifyContent: "center", marginTop: 4 }}>
				<Alert severity="error" className="error-alert">
					{error}
				</Alert>
			</Box>
		);
	}

	// If no products, display a message
	if (products.length === 0) {
		return (
			<Box sx={{ display: "flex", justifyContent: "center", marginTop: 4 }}>
				<Alert severity="info" className="error-alert">
					No Products Found for the selected Machine
				</Alert>
			</Box>
		);
	}

	// Paginate the products based on pageSize and currentPage
	const startIndex = (currentPage - 1) * pageSize;
	const currentProducts = filteredProducts.slice(startIndex, startIndex + pageSize);

	if (!machineID) {
		return <PageNotFound />;
	}

	return (
		<div className="products-page">
			<PageTitle title={`${machine_name} | ${machine_number}`} />
			<div className="products-content">
				<div className="filters">
					<div className="filter-content">
						<ContextFilterAndSort
							value={productSearchTerm}
							onSearchChange={handleProductSearchChange}
							placeholder="Search Part(s)"
							options={sortOptions}
							selectedOption={sortOption}
							onSortChange={handleSortChange}
							showSearch={true}
							showSort={true}
						/>
						<Accordion
							defaultExpanded
							sx={{
								marginTop: "10px",
								borderRadius: "5px",
								boxShadow: "none",
								border: "1px solid #ddd",
							}}>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="panel1a-content"
								id="panel1a-header">
								<Typography sx={{ fontSize: "13px", fontWeight: "bold" }}>Part Type Filters</Typography>
							</AccordionSummary>
							<AccordionDetails className="filters-list">
								<FormControlLabel
									control={
										<Checkbox
											checked={selectedFilters.length === categoryArray.length}
											onChange={handleAllChange}
											value="All"
										/>
									}
									label={`All (${products.length})`} // Shows the total product count
								/>

								{categoryArray.map((productType) => {
									// Calculate the count of products for each ProductType
									const count = products.filter(
										(product) => product.ProductType === productType
									).length;

									const cpCount = products.filter((product) => product.changePart === true).length;
									// Define the label based on the product type
									let label = productType;

									return (
										products.some((product) => product.ProductType === productType) && (
											<FormControlLabel
												key={productType}
												control={
													<Checkbox
														checked={selectedFilters.includes(productType)}
														onChange={handleFilterChange}
														value={productType}
													/>
												}
												label={`${label} (${count})`} // Append the count to the label
											/>
										)
									);
								})}
							</AccordionDetails>
						</Accordion>
						<Accordion
							defaultExpanded
							sx={{
								marginTop: "10px",
								borderRadius: "5px",
								boxShadow: "none",
								border: "1px solid #ddd",
							}}>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="panel1a-content"
								id="panel1a-header">
								<Typography sx={{ fontSize: "13px", fontWeight: "bold" }}>Change Parts</Typography>
							</AccordionSummary>
							<AccordionDetails className="filters-list">
								{products.some((product) => product.changePart === true) && (
									<FormControlLabel
										key="ChangeParts"
										control={
											<Checkbox
												checked={selectedChangePart}
												onChange={handleShowChangeParts}
												value="ChangeParts"
											/>
										}
										label={`Change Parts (${
											products.filter((product) => product.changePart === true).length
										})`}
									/>
								)}
							</AccordionDetails>
						</Accordion>
						<Box
							sx={{
								display: "flex",
								flexDirection: "row",
								alignItems: "center",
								justifyContent: "flex-start",
								columnGap: 2,
								marginTop: 2,
								width: "100%",
							}}>
							{(has3DModel || hasMultiple3DModels) && (
								<Button
									variant="contained"
									startIcon={<ViewInArIcon />}
									onClick={() => handle3DButtonClick()}>
									{m3DButtonLoading ? (
										<>
											Loading
											<CircularProgress color="white" size={20} sx={{ marginLeft: "5px" }} />{" "}
										</>
									) : (
										"3d Model"
									)}
								</Button>
							)}
							<Button
								variant="contained"
								startIcon={<DescriptionIcon />}
								onClick={() => navigate(`/documents/${machineID}`)}>
								Documentation
							</Button>
						</Box>
					</div>
				</div>
				<Divider flexItem orientation="vertical" sx={{ my: 0.5 }} />
				<div className="products">
					<div className="products-list">
						{currentProducts.map((product) => (
							<div key={product.product_id}>
								<ProductCard product={product} machineID={machineID} showSavedForLaterDial={true} />{" "}
								{/* Use ProductCard here */}
							</div>
						))}
					</div>
					{/* Pagination */}
					<Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
						<Pagination
							count={totalPages}
							page={currentPage}
							onChange={(event, value) => setCurrentPage(value)}
							color="primary"
						/>
					</Box>
				</div>
			</div>
			<MultipleModelViewer
				show={modalOpen}
				setShow={setModalOpen}
				machine_number={machine_number}
				machine_name={machine_name}
				machine_id={machineID}
			/>
		</div>
	);
};

export default Products;
